import AppModal from './AppModal.vue';
import AppModalsContainer from './AppModalsContainer.vue';

const Plugin = {
  install(Vue) {
    if (this.installed) { return; }
    this.installed = true;
    this.event = new Vue();
    this.modalsContainer = null;
    Vue.prototype.$modal = {
      setContainer(modalsContainer) {
        Plugin.modalsContainer = modalsContainer;
      },
      show(modal, props, events) {
        Plugin.modalsContainer.add(modal, props, events);
      }
    };

    Vue.component('app-modal', AppModal);
    Vue.component('app-modals-container', AppModalsContainer);
  }
};

export default Plugin;